import React from 'react';

import { PrimaryFilters as PrimaryFiltersProvider } from 'components/Filters';

import {
  FILTER_APPLICATIONS,
  FILTER_FILTER_BY,
  FILTER_CREATIVES_ADDED,
  FILTER_CONCEPTS_ADDED,
  FILTER_REQUESTED_BY,
  FILTER_CONCEPT_FAMILIES,
  FILTER_INVERT_AFFILIATE_FILTER,
} from 'scenes/Gallery/GalleryPage/constants';
import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';

import Filters from './filters';

export const PRIMARY_FILTERS = [
  FILTER_CONCEPTS_ADDED,
  FILTER_CREATIVES_ADDED,
  FILTER_APPLICATIONS,
  FILTER_REQUESTED_BY,
  FILTER_CONCEPT_FAMILIES,
  FILTER_FILTER_BY,
  FILTER_INVERT_AFFILIATE_FILTER,
];

const PrimaryFilters = () => {
  const {
    isAllowRequestedBy,
    isAllowDesigner,
    isAllowOutsourceStudio,
    isAllowPerformance,
    isAllowConceptFamilies,
    isAllowStatuses,
    isAllowBusinessPartner,
    isAllowSharedWith,
    isAllowPromoCodes,
    isAllowExclusiveForAffiliates,
    isAllowTested,
    isAllowProductionType,
  } = useGalleryPermissions();
  return (
    <PrimaryFiltersProvider primary={PRIMARY_FILTERS}>
      <Filters.ConceptsAdded />
      <Filters.CreativesAdded withClear={true} />
      <Filters.StartPeriod withClear={true} />
      <Filters.ExpirationPeriod withClear={true} />
      <Filters.Applications withClear={true} />
      <Filters.Channels withClear={true} />
      <Filters.Networks withClear={true} />
      {isAllowExclusiveForAffiliates ? (
        <Filters.ExclusiveForAffiliates withClear={true} />
      ) : null}
      <Filters.OS withClear={true} />
      <Filters.Genres withClear={true} />
      <Filters.CreativeTypes withClear={true} />
      <Filters.Orientations withClear={true} />
      <Filters.Languages withClear={true} />
      <Filters.Sizes withClear={true} />
      <Filters.Resolutions withClear={true} />
      <Filters.Ratios withClear={true} />
      {isAllowProductionType ? (
        <Filters.ProductionTypes withClear={true} />
      ) : null}
      <Filters.Enhancers withClear={true} />
      <Filters.MediaTypes withClear={true} />
      {isAllowTested ? <Filters.Tested withClear={true} /> : null}
      <Filters.IncludedTags withClear={true} />
      <Filters.ExcludedTags withClear={true} />
      <Filters.AITaggingStatusTags withClear={true} />
      <Filters.AITags withClear={true} />
      {isAllowStatuses && <Filters.Statuses withClear={true} />}
      {isAllowConceptFamilies && <Filters.ConceptFamilies withClear={true} />}
      <Filters.Comments withClear={true} />
      {isAllowDesigner && <Filters.Designers withClear={true} />}
      {isAllowOutsourceStudio && <Filters.OutsourceStudios withClear={true} />}
      {isAllowRequestedBy && <Filters.RequestedBy withClear={true} />}
      <Filters.CreatedBy withClear={true} />

      <Filters.FilterBy withClear={true} />
      {isAllowPerformance && <Filters.UsedInAds withClear={true} />}
      {isAllowPerformance && (
        <Filters.UsedInAffiliates dropdownWidth={'440px'} withClear={true} />
      )}
      <Filters.IsNew withClear={true} />
      <Filters.AIGenerated withClear={true} />
      {isAllowPromoCodes && <Filters.PromoCodes withClear={true} />}
      <Filters.IncludeYTLink withClear={true} />
      <Filters.Lengths withClear={true} />
      {isAllowBusinessPartner && <Filters.BusinessPartners withClear={true} />}
      {isAllowSharedWith && <Filters.SharedWith withClear={true} />}
    </PrimaryFiltersProvider>
  );
};

export default PrimaryFilters;
